var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.958 0h-8.75C4.173 0 3.333.84 3.333 1.875v16.25c0 1.035.84 1.875 1.875 1.875h8.75c1.035 0 1.875-.84 1.875-1.875V1.875C15.833.84 14.993 0 13.958 0ZM9.583 18.75a1.25 1.25 0 1 1-.002-2.498 1.25 1.25 0 0 1 .002 2.498Zm4.375-4.219a.47.47 0 0 1-.469.469H5.677a.47.47 0 0 1-.469-.469V2.344a.47.47 0 0 1 .469-.469h7.812a.47.47 0 0 1 .469.469V14.53Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.44718ed3ea69a700df6f136bedd90833.svg";
export { ForwardRef as ReactComponent };